/** Dados fixos de SEO compartilhados pelo app (navegador) e pela pré-renderização do build. */

export const SITE_NAME = 'PlacaVerific'

/** URL pública definitiva, sem barra no final (VITE_SITE_URL). */
export const SITE_URL = (import.meta.env.VITE_SITE_URL?.trim() || 'https://placaverific.com.br').replace(/\/$/, '')

/** Imagem de compartilhamento (WhatsApp, Facebook, LinkedIn): 1200×630, em /public. */
export const DEFAULT_OG_IMAGE = '/og-image.png'

export const SUPPORT_EMAIL = 'suporte@placaverific.com.br'

/** "/consulta-gravame" → "https://placaverific.com.br/consulta-gravame". */
export function absoluteUrl(path: string) {
  if (/^https?:\/\//.test(path)) return path
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}

/** Remove a barra final para que "/guias/" e "/guias" tenham o mesmo endereço canônico. */
export function normalizePath(pathname: string) {
  const trimmed = pathname.replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}
